/** Единственный публичный домен лендинга (зеркала .pro/.ru/.online сняты с индексации). */
export const CANONICAL_SITE_HOST = "tezam.by";

export const CANONICAL_SITE_URL = `https://${CANONICAL_SITE_HOST}`;

/** SEO главной: один description в SSR (без дублей client-side). */
export const HOME_PAGE_TITLE = "Telegram Mini App с CRM и сайтом для бизнеса — TEZAM";

export const HOME_PAGE_DESCRIPTION =
    "Создайте Telegram Mini App с CRM и сайтом. Интернет-магазин, меню или онлайн-запись под вашим брендом. Готовые настройки для 8 отраслей и 42 ниш.";

/** Зеркала-дубли: 301 на tezam.by в middleware. */
export const LEGACY_MIRROR_HOSTS = new Set([
    "tezam.pro",
    "www.tezam.pro",
    "tezam.ru",
    "www.tezam.ru",
    "tezam.online",
    "www.tezam.online",
]);

/** Prod — публичный сайт для SEO; dev/staging — закрыт от индексации. */
export const isProdSite = (): boolean => process.env.NEXT_PUBLIC_ENV === "prod";

export const isDevSite = (): boolean => !isProdSite();

export const PROD_ROBOTS_META = "index,follow,max-image-preview:large";

export const DEV_ROBOTS_META = "noindex,nofollow,noarchive,nosnippet";

export const defaultPublicRobots = (): string =>
    isProdSite() ? PROD_ROBOTS_META : DEV_ROBOTS_META;
